<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.daily_statement")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.mode')" size="sm")
                  b-form-select(
                    ref="mode"
                    v-model="mode"
                    :options="options"
                    size="sm"
                    @change="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :placeholder='$t("ui.member_id")'
                    v-model="member_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="dailyStatementList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(working_date)="row")
                    span {{ $moment(row.item.working_date).format("YYYY-MM-DD") }}
                  template(v-slot:cell(cash_balance)="row")
                    b-link(:class="$helpers.getNumberClass(row.item.cash_balance)" @click="redirectTo(row.item, 'dailyWinlose')") #[b {{ row.item.cash_balance | currency }} ]
                  template(v-slot:cell(account_balance)="row")
                    b-link(:class="$helpers.getNumberClass(row.item.account_balance)" @click="redirectTo(row.item, 'dailyWinlose')") #[b {{ row.item.account_balance | currency }} ]
                  template(v-slot:cell(cash_opening)="row")
                    b-link(:class="$helpers.getNumberClass(row.item.cash_opening)" @click="redirectTo(row.item, 'dailyWinlose')") #[b {{ row.item.cash_opening | currency }} ]
                  template(v-slot:cell(account_opening)="row")
                    b-link(:class="$helpers.getNumberClass(row.item.account_opening)" @click="redirectTo(row.item, 'dailyWinlose')") #[b {{ row.item.account_opening | currency }} ]
                  template(v-slot:cell(settled_amount)="row")
                    b-link(:class="$helpers.getNumberClass(row.item.settled_amount)" v-b-modal.dailySettlement @click="setEditSelectedModal(row.item)") #[b {{ row.item.settled_amount | currency }} ]
                  template(v-slot:cell(cash_closing)="row")
                    b-link(:class="$helpers.getNumberClass(row.item.cash_closing)" @click="redirectTo(row.item, 'dailyWinlose')") #[b {{ row.item.cash_closing | currency }} ]
                  template(v-slot:cell(account_closing)="row")
                    b-link(:class="$helpers.getNumberClass(row.item.account_closing)" @click="redirectTo(row.item, 'dailyWinlose')") #[b {{ row.item.account_closing | currency }} ]
                  template(v-slot:bottom-row="row" v-if="showTotal")
                    td.text-right(colspan="3")
                      span #[b {{ $t("ui.sub_total") }}]
                      br
                      span #[b {{ $t("ui.grand_total") }} ]
                    td.text-right(:class="isMode(1)")
                      span(:class="$helpers.getNumberClass(subTotalCashBalance)") #[b {{ subTotalCashBalance | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalCashBalance)") #[b {{ grandTotalCashBalance | currency }} ]
                    td.text-right(:class="isMode(0)")
                      span(:class="$helpers.getNumberClass(subTotalAccountBalance)") #[b {{ subTotalAccountBalance | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalAccountBalance)") #[b {{ grandTotalAccountBalance | currency }} ]
                    td.text-right
                      span(:class="$helpers.getNumberClass(subTotalSettledAmount)") #[b {{ subTotalSettledAmount | currency }}]
                      br
                      span(:class="$helpers.getNumberClass(grandTotalSettledAmount)") #[b {{ grandTotalSettledAmount | currency }} ]
                    td(colspan="1")

      dailySettlement(:accountID="updateAccountID" :date="updateDate")
</template>

<script>
import { required } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton.vue";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import DatePicker from "@/library/DatePicker.vue";
import dailySettlement  from "@/components/modal/dailySettlement.vue"

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DateRangePicker,
    DatePicker,
    dailySettlement
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      member_id: this.$store.getters.getSelectedID,
      updateAccountID: "",
      updateDate: "",
      mode: 0,
      options: [
        { value: 0, text: this.$t("ui.account_balance") },
        { value: 1, text: this.$t("ui.cash_balance") }
      ],
      dailyStatementList: [],
      subTotalSettledAmount: 0,
      grandTotalSettledAmount: 0,
      subTotalCashBalance: 0,
      grandTotalCashBalance: 0,
      subTotalAccountBalance: 0,
      grandTotalAccountBalance: 0,
      showTotal: false,
      filter: null,
      sortBy: "working_date",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "working_date",
          label: this.$t("ui.date_time"),
          sortable: true,
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "cash_opening",
          label: this.$t("ui.opening_balance"),
          sortable: true,
          class: "align-middle text-right " + this.isMode(1),
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "account_opening",
          label: this.$t("ui.opening_balance"),
          sortable: true,
          class: "align-middle text-right " + this.isMode(0),
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "cash_balance",
          label: this.$t("ui.cash_balance"),
          class: "align-middle text-right " + this.isMode(1),
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "account_balance",
          label: this.$t("ui.account_balance"),
          sortable: true,
          class: "align-middle text-right " + this.isMode(0),
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "settled_amount",
          label: this.$t("ui.amount"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "cash_closing",
          label: this.$t("ui.accumulate_balance"),
          sortable: true,
          class: "align-middle text-right " + this.isMode(1),
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "account_closing",
          label: this.$t("ui.accumulate_balance"),
          sortable: true,
          class: "align-middle text-right " + this.isMode(0),
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "15%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    if(this.member_id != "") {
      this.submit()
    } else {
      this.member_id = this.$store.getters.accountID
      this.submit()
    }
  },
  methods: {
    isMode: function(x) {
      if (this.mode == x) {
        return ""
      } else if (this.mode == x) {
        return ""
      } else {
        return "d-none"
      }
    },
    redirectTo: function(account, page) {
      this.$store.dispatch("layout/setDateRange", this.dateRange);
      this.$router.push("/" + page)
    },
    setEditSelectedModal: function(account) {
      this.updateAccountID = account.account_id
      this.updateDate = account.working_date
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let search_id = (this.member_id == "") ? this.$store.getters.accountID : this.member_id
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getDailyStatement", { search_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.clearTotal()
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.showTotal = true

                response.data.forEach(value => {
                  this.subTotalCashBalance = this.subTotalCashBalance + value["cash_balance"];
                  this.subTotalAccountBalance = parseFloat(this.subTotalAccountBalance) + parseFloat(value["account_balance"]);
                  this.subTotalSettledAmount = parseFloat(this.subTotalSettledAmount) + parseFloat(value["settled_amount"]);
                })

                if(response.grandTotal.length > 0) {
                  this.grandTotalCashBalance = response.grandTotal[0]["cash_balance"];
                  this.grandTotalAccountBalance = response.grandTotal[0]["account_balance"];
                  this.grandTotalSettledAmount = response.grandTotal[0]["settled_amount"];
                }

                this.dailyStatementList = response.data
                this.totalRows = response.data.length > 0 ? this.dailyStatementList[0]["totalrows"] : 0
              } else {
                this.clearTotal()
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.clearTotal()
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    clearTotal() {
      this.$store.dispatch("user/setSelectedID", "")
      this.showTotal = false
      this.dailyStatementList = []
      this.totalRows = 0
      this.subTotalCashBalance = 0
      this.grandTotalCashBalance = 0
      this.subTotalAccountBalance = 0
      this.grandTotalAccountBalance = 0
      this.subTotalSettledAmount = 0
      this.grandTotalSettledAmount = 0
    }
  }
};
</script>

